
module.exports.DEFAULT_ENDPOINT = 'https://api.mapbox.com';



//////////////////
// WEBPACK FOOTER
// ./node_modules/mapbox/lib/constants.js
// module id = 241
// module chunks = 0